var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { "label-width": "0" } },
    [
      _c("el-divider", { staticClass: "custom-divider-margin-top" }, [
        _vm._v(_vm._s(_vm.i18nt("designer.setting.optionsSetting"))),
      ]),
      _vm._v(" "),
      _c("option-items-setting", {
        attrs: {
          designer: _vm.designer,
          "selected-widget": _vm.selectedWidget,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }